export default __webpack_public_path__ + "images/67f49e1eae0be0eeb86f73196020ed60.svg";